declare namespace $ {

	export class $bog_builderui_card extends $bog_builderui_div {
	}
	
}

//# sourceMappingURL=card.view.tree.d.ts.map